module.exports = __webpack_public_path__ + "media/images/athletes/3537-4114d4f73bf3f1a02d79139ea18b8a2f.png";